import { component } from 'common/util/ComponentDecorator';

@component
export default class formLogin {
	static classname = 'form-login';

	constructor($form) {
		this.$form = $form;
		this.$passwordField = this.$form.find('input.wa-onetime-password');
		this.loginFieldBlock = this.$form.find('.wa-login-form-wrapper .wa-field-login');
		this.loginField = this.loginFieldBlock.find('input[name="login"]');
		this.loginMessageBlock = this.$form.find('.wa-send-onetime-password-edit-link-wrapper');
		this.signUpBtn = this.$form.find('.wa-signup-url');
		this.header = this.$form.siblings('.form-login-title');
		this.socialsBlock = this.$form.siblings('.form-login-socials');

		this.init();
		this.initEventListeners();
		this.bindGlobalEvents();
	}


	get $required_inputs() {
		return this.$form.find('.wa-field--required input[type=text], .wa-field[data-is-required=1] input[type=text]');
	}

	init() {
		this.$form.find('.wa-login-submit').remove();
		this.$form.find('.wa-buttons-wrapper').append(
			'<button type="submit" class="form__btn btn btn--green wa-login-submit">Войти на сайт</button>');

		this.$form.find('.wa-request-onetime-password-button').html('Получить код');
		this.$form.find('.wa-login-form-fields input[name="login"]').attr('placeholder', '');

		if (this.$required_inputs.length) {
			this.$required_inputs.on('input', this.handleInput);
		}

		if (this.$passwordField.length > 0) {
			this.addBlocks();
			this.inputCode();
		}
	}

	getLoginType() {
		var type = undefined;
		var value = this.loginField.val();

		if (value.indexOf('@') > 0) {
			type = 'email';
		} else if (this.getPhoneValueLength(value) === 11) {
			type = 'phone';
		}

		return type;
	}

	getPhoneValueLength (value) {
		var phoneValue = Number(value.replace(/\D+/g,""));
		return String(phoneValue).length;
	}

	addBlocks() {
		let inputType = 'text';
		if (('ontouchstart' in window)) {
			inputType = 'number';
		}
		$('<div class="wa-field wa-field-code wa-field--not-decorate">'
			+ '<input class="code-digit" type="'+inputType+'" maxlength="1">'
			+ '<input class="code-digit" type="'+inputType+'" maxlength="1">'
			+ '<input class="code-digit" type="'+inputType+'" maxlength="1">'
			+ '<input class="code-digit" type="'+inputType+'" maxlength="1">'
			+ '</div>'
		).insertAfter(this.$passwordField);

		if (this.loginMessageBlock.length > 0) {
			this.loginMessageBlock.prepend('<span>Мы отправили код подтверждения на <span class="login-type" data-email="email" data-phone="номер"></span> <span class="login-text"></span></span>')
		}

		$('.js-login-form-actions').append('<div class="wa-code-url" style="display: none;">'
			+'<span class="link">Вход по <span class="wa-code-url__type" data-phone="почте" data-email="номеру телефона"></span></span>'
			+'</div>'
		);
	}

	inputCode() {
		var self = this;
		var codeFields = self.$form.find('.code-digit');

		if (codeFields.length > 0) {
			var code = '';
			function changeCode() {
				code = '';
				codeFields.each(function () {
					var field = $(this);
					var value = field.val().toString();

					code = code + value;
				});
				self.$passwordField.val(code);

				if (self.$passwordField.val().length === 4) {
					self.$form.find('.wa-login-submit').trigger('click');
				}
			}

			codeFields.on('input', function() {
				var field = $(this);
				field.val(field.val().replace (/[^\d]/g, ''));
				var value = field.val();
				changeCode();
				if (value.length > 0) {
					field.next().focus();
				}
			});

			codeFields.on('keydown', function(e) {
				var field = $(this);
				var value = field.val();
				if (e.key === 'Backspace'){
					e.preventDefault();
					if (value.length === 0 ) {
						field.prev().focus();
					} else {
						field.val('').trigger('input');
					}
				}
			})
		}
	}

	initEventListeners() {
		var self = this;
		var $passwordEditLink = this.$form.find('.wa-send-onetime-password-edit-link');

		if ($passwordEditLink.length > 0) {
			$passwordEditLink.on('click', function () {
				$('.code-digit').val('');
				self.header.text(self.header.data('title'));
				self.loginFieldBlock.removeClass('hide-field');
				self.$form.find('.wa-code-url').hide();
				self.socialsBlock.show();
				self.signUpBtn.show();
			});

			this.$form.find('.wa-code-url').on('click', function () {
				$passwordEditLink.trigger('click');
			});
		}
	}

	bindGlobalEvents() {
		var self = this;

		$(document).ajaxSuccess(function (event, xhr, settings, data) {
			if (settings.url === '/login/' && data["status"] === 'ok') {
				window.location.reload();
			}
		});

		$(document).ajaxSuccess(function (event, xhr, settings) {
			if (settings.url.indexOf('/login/?send_onetime_password=1') >= 0  && xhr.responseJSON.status !== 'fail') {
				var login = self.loginField.val();
				var timeOutError = $('.wa-error-msg[data-name="timeout"]');
				var codeFields = self.$form.find('.code-digit');
				var loginType = self.getLoginType();

				if (loginType !== undefined && timeOutError.length === 0) {
					var $loginTypeBlock = self.loginMessageBlock.find('.login-type');
					var $loginTextBlock = self.loginMessageBlock.find('.login-text');
					var $toggleButton = self.$form.find('.wa-code-url');
					var $toggleButtonTypeBlock = $toggleButton.find('.wa-code-url__type');

					$loginTypeBlock.text($loginTypeBlock.data(loginType));
					$loginTextBlock.text(login);
					self.header.text('Введите код');
					self.loginFieldBlock.addClass('hide-field');
					codeFields.first().focus();
					$toggleButtonTypeBlock.text($toggleButtonTypeBlock.data(loginType));
					$toggleButton.show();
					self.signUpBtn.hide();
					self.socialsBlock.hide();
				}
			}
		});
	}

	handleInput = () => {
		let count_required_filled = 0;
		this.$required_inputs.each(function () {
			if ($(this).val() !== '') {
				count_required_filled++;
			}
		});
	};
}
